export default __webpack_public_path__ + "static/media/ic-insta.06492fa2.svg";